/* eslint-disable max-classes-per-file -- small typed error discriminants for prompt strategist */

/** Discriminant for client-side axios timeout (no HTTP body). */
export class PromptStrategistTimeoutError extends Error {}

/**
 * HTTP failure for prompt-strategist calls. Carries only status — never response body.
 */
export class PromptStrategistHttpError extends Error {
  readonly httpStatus: number | undefined;

  constructor(httpStatus?: number) {
    super();
    this.httpStatus = httpStatus;
  }
}
